import './plugins/axios'

import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import './config/firebase'
import router from './router'
import store from './store'
import './assets/tailwind.css'

const app = createApp(App)
    .use(store)
    .use(router)
    .directive('click-outside', {
    bind(el, binding, vnode) {
        // eslint-disable-next-line no-param-reassign
        el.clickOutsideEvent = function (event) {
            // here I check that click was outside the el and his children
            // eslint-disable-next-line eqeqeq
            if (!(el == event.target || el.contains(event.target))) {
                // and if it did, call method provided in attribute value
                vnode.context[binding.expression](event);
            }
        };
        document.body.addEventListener('click', el.clickOutsideEvent);
    },
    unbind(el) {
        document.body.removeEventListener('click', el.clickOutsideEvent);
    },
})

app.config.globalProperties.$filters = {
  formatDate(value) {
    if (value) {
      return new Intl.DateTimeFormat('en-US', {year: 'numeric', month: 'long', day: 'numeric'}).format(new Date(Date.parse(value)))
    }
  }
}

app.mount('#app')
